import TopBusinessQuotesWrapper from "@components/layouts/topBusinessQuotesWrapper";
import CategoryForm from "@components/topbusinessquotes/categoryForm";
import WhyTopBusinessQuotes from "@components/topbusinessquotes/whyTopBusinessQuotes";
import { getPageProps } from "@services/initial-calls";
import { GetServerSideProps } from "next";
import React, { ReactElement } from "react";
import { useDomainContext } from "@hooks/useDomainContext";
import OffersList from "@components/shared/offersList";
export default function QuotoCategoryPage(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <TopBusinessQuotesWrapper>
            <CategoryForm />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <WhyTopBusinessQuotes />
        </TopBusinessQuotesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "category");
};
